/* eslint-disable */
import Vue from 'vue'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
import en from 'vee-validate/dist/locale/en'
import Ajv from 'ajv'

for (const rule in rules) {
  extend(rule, {
    ...rules[rule],
    message: en.messages[rule]
  })
}
extend("decimal", {
  params: ['decimals'],
  validate: (value, { decimals = '*', separator = '.' } = {}) => {
    if (value === null || value === undefined || value === '') {
      return {
        valid: false
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
    const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

    return {
      valid: regex.test(value),
    };
  },
  message: 'The {_field_} field must contain only decimal values'
})

extend('validateName', {
  validate: (value) => {
    const regex = /^[a-zA-Zก-๙()\s]+$/
    let validateResult = regex.test(value)
    return validateResult
  },
  message: (fiedName) => {
    return app.i18n
      .t('validate.validate_name')
      .replace('{fieldName}', fiedName)
  },
})

extend('url', {
  validate(value) {
    if (value) {
      if (value.startsWith("http://localhost")) {
        return true;
      } else
        return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(value);
    }

    return false;
  },
  message: 'This value must be a valid URL',
})

extend('duplicateName', { // **Rule For validate duplicate name from restful api method Head
  validate(value, { validateFlag, msg }) {
    return !validateFlag;
  },
  params: ['validateFlag', 'msg'],
  message: (fieldName, objProvider) => {
    return objProvider.msg
  },
})

extend('notfoundValue', { // **Rule For validate duplicate name from restful api method Head
  validate(value, { validateFlag, msg }) {
    return !validateFlag;
  },
  params: ['validateFlag', 'msg'],
  message: (fieldName, objProvider) => {
    return objProvider.msg
  },
})

extend('dynamicRequired', {
  ...rules.required,
  params: ['msg'],
  message: (fieldName, objProvider) => {
    return objProvider.msg
  },
})

extend('validateEnglish', {
  validate(value) {
    var letters = /^[a-zA-Z]*$/i
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาอังกฤษเท่านั้น',
})

extend('validateEnglishSpace', {
  validate(value) {
    var letters = /^[a-zA-Z ]*$/i
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาอังกฤษเท่านั้น',
})

extend('validateEnglishEmail', {
  validate(value) {
    var letters = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/i
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นรูปแบบอีเมลภาษาอังกฤษเท่านั้น',
})

extend('validateEngWithSpecialCharacters', {
  validate(value) {
    var letters = /^[ '"A-Za-z_0-9-_.+&'#@/\\\\(),]*$/i
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาอังกฤษเท่านั้น',
})

extend('validateSeriesAndAttributeEngWithSpecialCharacters', {
  validate(value) {
    var letters = /^[ '"A-Za-z_0-9-_.+&'#@/\\\\(),]*$/i
    if (value) {
      return letters.test(value)
    }

    return false
  },
  message: 'กรุณาระบุเป็นภาษาอังกฤษเท่านั้น',
})

extend('validateEmployee', {
  validate(value, { validateFlag, msg }) {
    return !validateFlag;
  },
  params: ['validateFlag', 'msg'],
  message: (fieldName, objProvider) => {
    return objProvider.msg
  },
})

extend('validateJson', {
  validate(value) {
    const ajv = new Ajv()
    try {
      const data = JSON.parse(value)
      const schema = {} // your JSON schema here
      const validate = ajv.compile(schema)
      // console.log('error json', validate.errors[0].message)
      return validate(data)
    } catch (err) {
      return false
    }
    
  },
  message: 'กรุณาระบุเป็น format json เท่านั้น',
})

Vue.component('validationProvider', ValidationProvider)
Vue.component('validationObserver', ValidationObserver)
